import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LogError } from '@memberjunction/core';
import { arrowLeftIcon } from '@progress/kendo-svg-icons';
import { SubscriptionEntityExtended } from 'mj_generatedentities';
import { UserContextService } from 'src/app/core/services/user-context.service';
import { SharedService } from 'src/app/core/services/shared-service';
import { PlanCard, SubscriptionPlanService, SubscriptionPreviewOptions } from 'src/app/core/services/subscription-plan.service';
import { PriceTableComponent } from 'src/app/shared/price-table/price-table.component';
import { SubscriptionUpdatePreviewComponent } from '../subscription-update-preview/subscription-update-preview.component';

@Component({
  selector: 'app-subscription-update',
  templateUrl: './subscription-update.component.html',
  styleUrl: './subscription-update.component.css'
})
export class SubscriptionUpdateComponent implements OnInit, AfterViewInit {
  @ViewChild(PriceTableComponent) priceTableComponent!: PriceTableComponent;
  @ViewChild(SubscriptionUpdatePreviewComponent) subscriptionUpdatePreviewComponent!: SubscriptionUpdatePreviewComponent;

  subscriptionID: string;
  subscription: SubscriptionEntityExtended;

  showSubscriptionChangeDialog = false;
  selectedPlan: PlanCard | null = null;
  selectedCycleID: string;
  previewOptions: SubscriptionPreviewOptions = null;

  isSaving = false;
  savingMessage = 'Saving...';

  isPreviewLoaded = false;

  arrowLeftIcon = arrowLeftIcon;
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private sharedService: SharedService,
    private userContextService: UserContextService,
    private subscriptionService: SubscriptionPlanService
  ) {}

  async ngOnInit(): Promise<void> {
    // Extract subscription ID from URL snapshot
    this.subscriptionID = this.route.snapshot.paramMap.get('subscriptionId')!;
    this.subscription = this.userContextService.Subscriptions.find(sub => sub.ID === this.subscriptionID);
  }


  ngAfterViewInit(): void {
    if (this.priceTableComponent) {
      this.priceTableComponent.SetOnSelectionCallback(async (sub: PlanCard, cycleID: string) => {
        await this.handlePlanSelection(sub, cycleID);
      });
    }
  }

  async handlePlanSelection(sub: PlanCard, cycleID: string): Promise<void> {
    this.selectedPlan = sub;
    this.selectedCycleID = cycleID;
    const newPriceID = sub.PriceData.get(cycleID).PriceID;

    this.previewOptions = {
      NewPriceID: newPriceID,
    };

    this.showSubscriptionChangeDialog = true;
  }

  closeSubscriptionChangeDialog(): void {
    this.showSubscriptionChangeDialog = false;
    this.selectedPlan = null;
    this.selectedCycleID = '';
  }

  async confirmSubscriptionChange(): Promise<void> {
    if (!this.selectedPlan || !this.selectedCycleID || !this.isPreviewLoaded) {
      console.error('Selected plan or cycle is not defined, cannot confirm subscription change.');
      return;
    }
    // 1. Show loading state
    this.isSaving = true;
    this.savingMessage = 'Processing...';

    const newPriceID = this.selectedPlan.PriceData.get(this.selectedCycleID).PriceID;
    const contactID = this.userContextService.Contact.ID;
    const result = await this.subscriptionService.UpdateSubscription(this.subscription, contactID, { NewPriceID: newPriceID });

    if (result.Success) {
      this.sharedService.DisplayNotification(result.Message, 'success', 3000);
      await this.priceTableComponent.loadData(); // Refresh the price table to reflect the new subscription
      this.router.navigate(['/settings/subscription', this.subscriptionID, 'details']);
    } else {
      LogError(result.Message);
      this.sharedService.DisplayNotification('Failed to update subscription. Please try again later.', 'error', 3000);
    }
    this.isSaving = false;
    this.closeSubscriptionChangeDialog();
  }

  onBack(): void {
    this.router.navigate(['/settings/subscription', this.subscriptionID, 'details']);
    this.closeSubscriptionChangeDialog();
  }

  onPreviewLoaded(isLoaded: boolean): void {
    this.isPreviewLoaded = isLoaded;
  }
}
